import { NgModule } from '@angular/core';
import { NumberTickerComponent } from './number-ticker.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        NumberTickerComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        NumberTickerComponent
    ]
})
export class NcNumberTickerModule { }